<script setup lang="ts">
import ModalContainer from '@/components/modal/modal-container.vue'
import ModalTitle from '@/components/modal/modal-title.vue'
import ModalContent from '@/components/modal/modal-content.vue'
import InputTextarea from '@/components/input-textarea.vue'
import { ref } from 'vue'
import ModalFooterConfirmation from '@/components/modal/modal-footer-confirmation.vue'
import { faFloppyDisk } from '@fortawesome/pro-regular-svg-icons'

const emit = defineEmits<{ close: [], 'update:value': [string] }>()
defineProps<{ value: string|undefined }>()
const currentValue = ref<string>()

function persistValue() {
  if (currentValue.value !== undefined) {
    emit('update:value', currentValue.value)
  }

  emit('close')
}
</script>

<template>
<ModalContainer>
  <ModalTitle>Special Conditions</ModalTitle>
  <ModalContent>
    <InputTextarea :value="value" @update:value="currentValue = $event" placeholder="Please add special conditions here." />
  </ModalContent>
  <ModalFooterConfirmation
    @reject="$emit('close')"
    @confirm="persistValue"
    reject-text="Cancel"
    confirm-text="Apply"
    :confirm-icon="faFloppyDisk" />
</ModalContainer>
</template>
